import styled from 'styled-components';

export const FormWrap = styled.form`
  position: relative;
  width: calc(400px + (16px * 2));
  margin: 0 auto;
  padding-top: 32px;
`;

export const ForgotPassContainer = styled.div`
  width: 100vw;
  min-height: calc(100vh - 56px);
  display: flex;
  flex-direction: row;
`;
